export default {
  // Navbar
  "nav.about": "회사소개",
  "nav.maintenance": "서비스",
  "nav.satellite": "위성통신",
  "nav.security": "솔루션",
  "nav.performance": "사업실적",
  "nav.support": "고객지원",
  "nav.contact": "문의하기",

  // Hero
  "hero.badge": "SHIP IT SUPPORT · VESSEL IT EXPERT · SINCE 2019",
  "hero.live": "24/365 헬프데스크 운영 중",
  "hero.title1": "선박 IT",
  "hero.title2": "통합관리 파트너",
  "hero.desc1": "고객의 안전운항을 책임지는 선박IT 전문기업.",
  "hero.desc2": "오션커넥트는 200여 척 선박의 IT 자산을 24/365 통합 관리합니다.",

  // Performance
  "perf.heading1": "숫자로 증명하는",
  "perf.heading2": "신뢰",
  "perf.stat1.d": "현재 통합 관리 선박",
  "perf.stat2.d": "누적 지원 선박",
  "perf.stat3.d": "누적 서비스 수행 (86개월 무중단)",
  "perf.stat4.d": "원격 즉시 해결률",
  "perf.stat5.d": "방선 작업 (출장 749회)",
  "perf.stats.note": "2019.05 ~ 2026.06 서비스 이력 기준",
  "perf.card1.title": "서비스 운영 실적",
  "perf.card1.desc": "현재 200여 척 통합 IT 유지보수를 운영 중입니다. 국내외 선사와 장기 계약을 이어가며 컨테이너 · 벌크 · 탱커 · PCTC · 가스선 등 전 선종을 지원하고 있습니다.",
  "perf.card1.i1": "PAN OCEAN 사선 전선대 통합 IT 관리계약 · 2019~현재",
  "perf.card1.i2": "STX OCEANSERVICE 관리선 통합 IT 관리계약 · 2023~현재",
  "perf.card1.i3": "하나로해운 사선 전선대 통합 IT 관리계약 · 2026~현재",
  "perf.card1.i4": "KDDI 관리선 위성통신 커미셔닝 · 선단 보안장비 일괄 구축",
  "perf.card2.title": "현장 · 원격 대응 역량",
  "perf.card2.desc": "원격 지원으로 항해 중에도 즉시 문제를 해결하고, 국내 접안 시 방선과 해외 조선소 신조 방선까지 직접 수행합니다.",
  "perf.card2.i1": "원격 지원 14,369건 · 원격 즉시 해결률 93.5%",
  "perf.card2.i2": "방선 점검 375건(202척) · 신조 312건(104척) · 설치/수리 304건",
  "perf.card2.i3": "방선 991건 · 출장 749회 · 투입 1,207일",
  "perf.card2.i4": "해외 조선소 신조 방선 151회 · 신조/인수 방선의 60% 이상 해외 수행",
  "perf.more": "문의하기",

  // Partners
  "partners.title": "국내외 선사 · 통신사 · 기자재 파트너와 함께합니다",
  "partners.desc": "PAN OCEAN, STX OCEANSERVICE, 하나로해운 등 국내외 선사와 KDDI 등 통신사, 기자재 협력사와의 파트너십으로 글로벌 해양 IT 서비스를 제공합니다.",

  // News
  "news.heading": "오션커넥트의 새로운 소식",
  "news.sub": "공지사항, 사업소식, 기술 자료, 채용 정보를 확인하세요.",
  "news.viewall": "공지사항 전체보기",
  "news.more": "자세히 보기",
  "news.n1.cat": "공지사항",
  "news.n1.title": "오션커넥트 홈페이지 리뉴얼 오픈",
  "news.n1.excerpt": "선박 IT 통합관리솔루션 전문기업 오션커넥트의 새로운 홈페이지가 오픈되었습니다.",
  "news.n2.cat": "사업소식",
  "news.n2.title": "하나로해운 사선 전선대 통합 IT 관리계약 체결",
  "news.n2.excerpt": "하나로해운 사선 전선대의 방선 · 원격지원 · 선용품 공급을 포함한 통합 IT 관리를 시작합니다.",
  "news.n3.cat": "기술자료",
  "news.n3.title": "선박 스타링크(STARLINK Maritime) 설치 · 커미셔닝 체크리스트",
  "news.n3.excerpt": "스타링크 선박 도입 전 꼭 확인할 6단계 — 안테나 위치, UPS, 방화벽 연동, VSAT 페일오버, 시험 · 인수까지 선박 스타링크를 선내 네트워크에 제대로 연동하는 방법.",
  "news.n4.cat": "기술자료",
  "news.n4.title": "선급 사이버보안 규정 IACS UR E26 · E27 대응 가이드",
  "news.n4.excerpt": "2024년 7월 이후 신조선에 적용되는 UR E26 · E27 의 요구사항과 현장에서 가장 많이 지적되는 항목, 오션커넥트의 대응 방법.",
  "news.n16.cat": "기술자료",
  "news.n16.title": "선박용 CCTV 설치 가이드: 카메라 위치 · 녹화기 · 해상 환경 대응",
  "news.n16.excerpt": "선박용 CCTV를 설치할 때 카메라 위치 선정, 진동 · 염분 · 습기 · 야간 촬영 대응, 녹화기 보관 기간과 시간 맞추기, 망 분리와 보안, 녹화 점검까지 순서대로 정리했습니다.",
  "news.n15.cat": "기술자료",
  "news.n15.title": "선박 위성전화기 고르는 법: 선내 설치형과 휴대용, 인마샛 서비스 이해하기",
  "news.n15.excerpt": "선박 인터넷과 별도로 갖추는 위성전화기의 역할, 인마샛 위성전화 서비스(GSPS)의 커버리지 · 번호 · SIM, 선내 설치형과 휴대용 IsatPhone 2의 차이, 설치 위치와 비상시 점검 수칙까지 정리했습니다.",
  "news.n14.cat": "기술자료",
  "news.n14.title": "선박 디지털 경사계 기록 읽는 법: 화물 작업 · 악천후 항해에서 롤 · 피치 보기",
  "news.n14.excerpt": "롤 · 피치 값을 '기울어진 채 머무는 값'과 '흔들리는 폭'으로 나눠 읽는 법, 화물 작업 중 중심값 변화와 악천후 항해의 흔들림 폭 · 주기 보기, 기록 재생과 이상값 점검까지 선박 전자경사계 활용법을 정리했습니다.",
  "news.n13.cat": "기술자료",
  "news.n13.title": "선박 디지털 경사계(전자경사계) 고르는 법과 설치 위치",
  "news.n13.excerpt": "진자식과 디지털 경사계의 차이, 선박 전자경사계를 고를 때 볼 것, 설치 위치와 영점 확인, 화물 작업 · 악천후 항해에서의 활용법을 정리했습니다.",
  "news.n12.cat": "기술자료",
  "news.n12.title": "선박 사이버보안 매뉴얼 · 사고 대응 절차서에 꼭 넣을 항목",
  "news.n12.excerpt": "심사용 서류가 아니라 실제 사고 때 따라 할 수 있는 매뉴얼을 위해 범위 · 책임자, 평상시 관리 규칙, 사고 대응 5단계, 선박 현실에 맞는 작성 요령과 훈련 · 개정 방법을 정리했습니다.",
  "news.n11.cat": "기술자료",
  "news.n11.title": "IACS UR E26 · E27 대응 체크리스트: 자산 목록 · 망분리 · 증빙 준비 순서",
  "news.n11.excerpt": "UR E26 · E27 대응을 어디서부터 시작할지 막막한 선사 담당자를 위해 자산 목록 · 망분리 · 보호 수단 · 탐지 · 대응 · 증빙 자료 순서로 준비 단계를 정리했습니다.",
  "news.n9.cat": "기술자료",
  "news.n9.title": "선박 IT 관리 가이드: 선내 IT 시스템 구성부터 유지보수 · 보안 · 통신까지",
  "news.n9.excerpt": "선박 IT는 무엇을 말하고, 선내에는 어떤 IT 시스템이 있으며, 바다 위에서는 어떻게 관리해야 할까요? 선사 IT · 안전 담당자를 위해 선박 IT 관리의 범위와 핵심 원칙을 정리했습니다.",
  "news.n8.cat": "기술자료",
  "news.n8.title": "선박 사이버보안 훈련(드릴) 시나리오 5가지와 실시 방법",
  "news.n8.excerpt": "랜섬웨어, USB 악성코드, 피싱 메일, 위성 회선 두절, GNSS 신호 이상 — 선원이 바로 따라 할 수 있는 선박 사이버보안 훈련 시나리오 5가지와 준비 · 기록 방법을 정리했습니다.",
  "news.n7.cat": "기술자료",
  "news.n7.title": "선박 사이버보안 총정리: 주요 위협 · 국제 규정 · 대응 체계",
  "news.n7.excerpt": "선박 사이버보안이 왜 중요해졌는지, 선박을 노리는 주요 사이버 위협과 IMO · IACS 국제 규정, 식별 · 보호 · 탐지 · 대응 · 복구 5단계 대응 체계와 선원 보안 수칙까지 한 번에 정리했습니다.",
  "news.n6.cat": "기술자료",
  "news.n6.title": "미흡한 방화벽 정책이 선박을 보안사고에 노출시키는 이유",
  "news.n6.excerpt": "방화벽이 있어도 정책이 미흡하면 없는 것과 같습니다. 선박에서 실제로 발생하는 보안사고 유형과 미흡한 정책의 전형적인 모습, 바로잡는 방법.",
  "news.n5.cat": "기술자료",
  "news.n5.title": "선박 IT 장애를 줄이는 예방 점검 7가지",
  "news.n5.excerpt": "서버 · PC, 백업 복구 시험, UPS 배터리, 네트워크 장비, 위성통신, 보안, 원격 지원 준비 — 매 방선 때 확인하는 예방 점검 항목.",

  // Contact
  "contact.title1": "함께 만들어갈",
  "contact.title2": "안전운항의 미래",
  "contact.desc": "선박 IT 통합관리솔루션이 필요하신가요? 오션커넥트의 전문 엔지니어가 24/7 최적의 기술지원을 제공합니다.",
  "contact.info1.title": "본사 위치",
  "contact.info1.value": "부산광역시 남구 신선로 365, 용당9관 218호",
  "contact.info2.title": "전화 · 팩스",
  "contact.info2.value": "T. 051-715-0611   |   F. 051-715-0613",
  "contact.info3.title": "이메일",
  "contact.info3.value": "info@oceanconnect.co.kr",
  "contact.info4.title": "운영 시간",
  "contact.info4.value": "평일 09:00 - 18:00",
  "contact.info4.hint": "긴급 24시간 대응",
  "contact.info5.title": "장애 접수 헬프데스크 (24H)",
  "contact.info5.value": "070-7588-0611 ~ 0612",
  "contact.kakao.title": "카카오톡 채널",
  "contact.kakao.value": "오션커넥트 선박 IT 지원",
  "contact.kakao.hint": "카카오톡에서 채널명을 검색해 주세요",
  "contact.success.title": "문의가 접수되었습니다",
  "contact.success.desc": "빠른 시일 내에 담당자가 연락드리겠습니다. 감사합니다.",
  "contact.new": "새 문의 작성",
  "contact.form.name": "이름",
  "contact.form.company": "회사 / 소속",
  "contact.form.email": "이메일",
  "contact.form.phone": "연락처",
  "contact.form.category": "문의 유형",
  "contact.form.message": "문의 내용",
  "contact.placeholder.name": "홍길동",
  "contact.placeholder.company": "○○해운",
  "contact.placeholder.phone": "010-0000-0000",
  "contact.category.default": "문의 유형을 선택하세요",
  "contact.category.maintenance": "선박 IT 통합 유지보수",
  "contact.category.network": "네트워크 구축 · 컨설팅",
  "contact.category.satellite": "위성통신 설치 · 커미셔닝",
  "contact.category.security": "사이버보안 (방화벽 · 엔드포인트 · USB)",
  "contact.category.newbuild": "신조 · 인수선 IT 구축",
  "contact.category.parts": "IT 기자재 · 선용품 공급",
  "contact.category.etc": "기타 문의",
  "contact.placeholder.message": "문의 내용을 입력해주세요. (최대 500자)",
  "contact.agree": "개인정보 수집 및 이용에 동의합니다. 수집된 정보는 문의 답변 목적으로만 사용됩니다.",
  "contact.err.length": "문의 내용은 500자 이내로 작성해주세요.",
  "contact.form.note": "담당자가 내용을 확인한 후 입력하신 연락처로 신속히 답변드립니다. 긴급 장애는 24시간 헬프데스크 070-7588-0611로 바로 연락해 주세요.",
  "contact.err.fail": "문의 전송에 실패했습니다. 잠시 후 다시 시도하시거나 051-715-0611로 전화 문의해 주세요.",
  "contact.err.network": "네트워크 오류가 발생했습니다. 잠시 후 다시 시도하시거나 051-715-0611로 전화 문의해 주세요.",
  "contact.submit": "문의 접수하기",
  "contact.sending": "전송 중...",

  // SEO
  "seo.home.title": "부산 선박 IT 유지보수 · 해양 IT 전문기업",
  "seo.home.desc": "부산 선박 IT · 해양 IT 서비스 전문기업 오션커넥트. 200여 척 선박의 IT 유지보수(Ship IT Support · Vessel IT Support), 선박 네트워크 구축, VSAT·STARLINK 위성통신 커미셔닝, 선박 사이버보안, 선박 원격관리를 제공하며 긴급 장애는 24시간 대응합니다.",
  "seo.solutions.title": "선박 사이버보안 · 원격관리 솔루션",
  "seo.solutions.desc": "선박 · 해양 사이버보안 전문 오션커넥트. 선박 사이버보안을 위한 선박 방화벽(UTM)·엔드포인트·USB 보안, 선박 원격관리(OCEAN-SUPPORT™), 네트워크 모니터링(Ocean-Spider™), 선단 방화벽 자동화와 CITADEL·CCTV 등 선박 기자재를 공급·구축합니다.",

  // Home: FAQ (검색 노출용 자주 묻는 질문)
  "faq.eyebrow": "FAQ",
  "faq.title": "자주 묻는 질문",
  "faq.q1": "선박 IT 유지보수는 어떤 범위를 포함하나요?",
  "faq.a1": "선내 PC · 서버 · 네트워크 · 방화벽 · UPS · 프린터 · CCTV 등 전산장비 전반의 예방 점검, 장애 복구, 신조 · 인수선 IT 구축, IT 기자재 · 선용품 공급까지 포함합니다. 오션커넥트는 200여 척 선박의 IT를 통합 관리하고 있습니다.",
  "faq.q2": "항해 중에도 원격으로 지원이 가능한가요?",
  "faq.a2": "네. 자체 개발한 원격관리 플랫폼 OCEAN-SUPPORT™로 위성통신 저대역 환경에서도 선박 PC와 서버에 안전하게 접속해 진단 · 조치합니다. 원격 즉시 해결률은 93.5%이며, 부팅이 되지 않는 PC도 PE USB를 통해 원격 복구할 수 있습니다.",
  "faq.q3": "VSAT · STARLINK 위성통신 장애대응과 커미셔닝도 하나요?",
  "faq.a3": "네, 가능합니다. 당사는 해상 통신 및 선박 전용 이메일 솔루션에 대한 높은 이해도와 경험을 갖추고 있습니다. VSAT, FBB, Iridium, Starlink Maritime, LTE 등 모든 해상 통신 시스템의 장애 대응이 가능하며, 커미셔닝부터 선내 네트워크 연동, 운항 중 발생할 수 있는 1차 통신 장애 해결까지 종합 솔루션을 제공합니다.",
  "faq.q4": "선박 사이버보안은 어떻게 대응하나요?",
  "faq.a4": "UTM 방화벽과 OT/IT 망분리, 엔드포인트 · USB 보안을 선단 단위로 구축하고, 자체 플랫폼 Ocean-Spider™로 선내 네트워크를 실시간 감시합니다. 선급 사이버보안 규정 대응을 위한 증적 생성도 지원합니다.",
  "faq.q5": "지원 가능한 지역과 시간은 어떻게 되나요?",
  "faq.a5": "부산 본사를 거점으로 부산 · 울산 · 광양 · 여수 · 포항 · 인천 · 평택 등 국내 주요 항만에 방선하며, 해외 기항지는 원격 지원과 출장으로 대응합니다. 긴급 24시간 대응 헬프데스크(070-7588-0611~0612)를 운영합니다.",
  "faq.more": "서비스 자세히 보기",

  // Home: intro (한 줄 메시지 + 핵심 숫자)
  "intro.eyebrow": "SHIP IT SUPPORT · VESSEL IT SUPPORT · MARITIME IT",
  "intro.line1": "우리는 바다 위 200여 척 선박의 IT를",
  "intro.line2": "육상에서 통합 관리합니다.",
  "intro.desc": "선박 IT 유지보수, 선박 네트워크 구축, 위성통신 커미셔닝, 선박 사이버보안, 원격관리를 하나의 체계로 묶어 선사의 '선박 IT 팀' 역할을 수행하는 부산의 해양 IT 전문기업입니다.",
  "intro.stat1": "현재 통합 관리 선박",
  "intro.stat2": "누적 서비스 수행 (86개월 무중단)",
  "intro.stat3": "원격 즉시 해결률",
  "intro.stat4": "상시 대응 체계",
  "intro.fleetNote": "PAN OCEAN · STX OCEANSERVICE · HANARO SHIPPING 사선 전선대 포함",
  "intro.platform.title": "자체 개발 플랫폼",
  "intro.platform.desc": "OCEAN-SUPPORT™ 원격관리 · Ocean-Spider™ 네트워크 모니터링",
  "intro.note": "2019.05 ~ 2026.06 서비스 이력 기준",
  "intro.more": "회사 소개 보기",

  // Home: business cards
  "cards.eyebrow": "BUSINESS AREAS",
  "cards.title1": "선박 IT의 모든 것,",
  "cards.title2": "오션커넥트 하나로",
  "cards.desc": "유지보수부터 위성통신, 사이버보안, 원격관리까지 선박 IT를 통합 관리하는 오션커넥트의 3대 사업 영역입니다.",
  "cards.c1.title": "서비스",
  "cards.c1.desc": "24/365 선박 IT 통합 유지보수, 네트워크 구축 · 컨설팅, 신조 · 인수선 IT 구축",
  "cards.c2.title": "솔루션",
  "cards.c2.desc": "선박 사이버보안(방화벽 · 엔드포인트 · USB 보안), RMM 원격관리, CITADEL · CCTV 등 선박 특수 기자재",
  "cards.c1.alt": "선박 IT 유지보수 현장",
  "cards.c2.alt": "선박 사이버보안 · 원격관리 솔루션",
  "cards.c3.alt": "선박 위성통신 VSAT 안테나",
  "cards.c3.title": "위성통신",
  "cards.c3.desc": "VSAT · FBB · IRIDIUM · STARLINK 설치 · 커미셔닝과 운항 중 통신 장애 1차 대응",

  // Solutions page
  "solutions.title": "선박 사이버보안 · 원격관리 솔루션",
  "solutions.desc": "선박 · 해양 사이버보안, 원격 관리, 안전운항을 위한 통신·안전 장비까지 오션커넥트가 공급하고 설치·커미셔닝하는 솔루션입니다.",
  "solutions.comingSoon": "준비중",
  "solutions.comingSoonDesc": "현재 준비 중인 솔루션입니다. 적용 범위는 협의에 따라 단계적으로 확대됩니다.",
  "solutions.more": "자세히 보기",
  "solutions.cta.title": "도입 문의",
  "solutions.cta.desc": "선박 환경과 선단 규모에 맞는 구성과 견적을 안내해 드립니다.",
  "solutions.cta.button": "문의하기",
  "solutions.related": "관련 솔루션",
  "solutions.screens": "화면 소개",
  "solutions.back": "솔루션 목록으로",

  // Notice page
  "notice.title": "공지사항",
  "notice.desc": "오션커넥트의 공지사항, 사업소식, 기술 자료, 채용 정보를 전해드립니다.",
  "notice.prev": "이전",
  "notice.next": "다음",
  "notice.list": "목록",
  "notice.related": "함께 읽으면 좋은 글",

  // Careers page
  "careers.title": "인재채용",
  "careers.duties": "담당 업무",
  "careers.requirements": "자격 요건",
  "careers.preferred": "우대 사항",
  "careers.benefits": "복지 · 근무환경",
  "careers.apply": "이메일로 지원하기",

  // Downloads page
  "downloads.title": "자료실",

  // Legal
  "legal.effective": "시행일",

  // 404
  "notfound.title": "페이지를 찾을 수 없습니다",
  "notfound.desc": "주소가 잘못되었거나 페이지가 이동·삭제되었을 수 있습니다.",
  "notfound.home": "홈으로 가기",

  // Footer
  "footer.desc": "선박 IT 통합관리 전문기업. 유지보수, 위성통신, 사이버보안, 원격관리와 긴급 24시간 기술지원으로 고객의 안전운항을 책임집니다.",
  "footer.g1.title": "회사소개",
  "footer.g1.l1": "회사개요",
  "footer.g1.l2": "조직 · 인력",
  "footer.g1.l3": "사업실적",
  "footer.g1.l4": "연혁",
  "footer.g2.title": "서비스",
  "footer.g2.l1": "IT 통합 유지보수",
  "footer.g2.l2": "네트워크 구축 · 컨설팅",
  "footer.g2.l3": "설치 · 커미셔닝",
  "footer.g2.l4": "신조 · 인수선 IT 구축",
  "footer.g3.title": "솔루션",
  "footer.g3.l1": "방화벽 · 엔드포인트",
  "footer.g3.l2": "USB 보안",
  "footer.g3.l3": "RMM 원격관리",
  "footer.g3.l4": "NMS 네트워크 모니터링",
  "footer.g4.title": "위성통신",
  "footer.g4.l1": "VSAT · FBB · IRIDIUM",
  "footer.g4.l2": "STARLINK Maritime",
  "footer.g4.l3": "CITADEL 비상통신",
  "footer.g4.l4": "선박 이메일",
  "footer.g5.title": "고객지원",
  "footer.g5.l1": "온라인문의",
  "footer.g5.l2": "인재채용",
  "footer.g5.l3": "다운로드",
  "footer.g5.l4": "공지사항",
  "footer.company": "주식회사 오션커넥트",
  "footer.ceo": "| 대표이사 이준원 | 사업자등록번호 618-87-01330 | 부산광역시 남구 신선로 365, 용당9관 218호",
  "footer.helpdesk": "장애 접수 헬프데스크(24H) 070-7588-0611 ~ 0612",
  "footer.tel": "T. 051-715-0611",
  "footer.fax": "F. 051-715-0613",
  "footer.privacy": "개인정보처리방침",
  "footer.terms": "이용약관",
  "footer.copyright": "© {{year}} OCEAN CONNECT CO., LTD. All Rights Reserved.",
};
